import type { FC } from "react";

import { ProjectsIcon, PromptInputPillButton } from "@hightouch/htui";

import { ProjectPicker } from "src/pages/projects/components/project-picker";
import { useOpenProjects } from "src/pages/projects/hooks";
import { projectLabel } from "src/pages/projects/use-linked-projects";

type Props = {
  selectedProjectIds: string[];
  onChange: (projectIds: string[]) => void;
  isDisabled?: boolean;
};

const PLACEHOLDER_LABEL = "Project";

/** Composer pill choosing the projects a new chat is added to once it starts. */
export const ProjectPill: FC<Props> = ({
  selectedProjectIds,
  onChange,
  isDisabled = false,
}) => {
  const { projects } = useOpenProjects();
  const selected = projects.filter((project) =>
    selectedProjectIds.includes(project.id),
  );
  const [first] = selected;
  const label = !first
    ? PLACEHOLDER_LABEL
    : selected.length === 1
      ? projectLabel(first)
      : `${selected.length} projects`;

  return (
    <ProjectPicker
      selectedProjectIds={selectedProjectIds}
      onToggle={(projectId, isSelected) =>
        onChange(
          isSelected
            ? [...selectedProjectIds, projectId]
            : selectedProjectIds.filter((id) => id !== projectId),
        )
      }
      trigger={
        <PromptInputPillButton
          variant="picker"
          icon={ProjectsIcon}
          label={label}
          isPlaceholder={selected.length === 0}
          tooltip="Add this chat to a project"
          aria-label={`Project: ${label}`}
          isDisabled={isDisabled}
        />
      }
    />
  );
};
